import React from 'react';
import { createPlayerWithFallback } from './MediaPlayerFactory';
import { detectProviderFromUrl } from '../../utils/providerDetector';

const MediaPlayer = ({ 
  mediaMapping, 
  fallbackUrl, 
  onTimeUpdate, 
  onComplete, 
  currentTime, 
  duration,
  className = "w-full h-full"
}) => {
  // Debug: log dos dados recebidos
  const detectedProvider = detectProviderFromUrl(fallbackUrl);
  console.log('🔍 MediaPlayer Debug:', {
    mediaMapping,
    fallbackUrl,
    mediaMappingUrl: mediaMapping?.library_url,
    mediaMappingProvider: mediaMapping?.provider,
    detectedProvider,
    finalProvider: mediaMapping?.provider || detectedProvider
  });

  // Debug adicional para verificar qual player está sendo renderizado
  console.log('🎬 MediaPlayer: Renderizando player para provider:', mediaMapping?.provider || detectedProvider);

  // Props para o player
  const playerProps = {
    onTimeUpdate,
    onComplete,
    currentTime,
    duration,
    className,
    config: mediaMapping?.config || {}
  };

  // Criar player usando a factory
  const player = createPlayerWithFallback(mediaMapping, fallbackUrl, playerProps);

  if (!player) {
    console.error('❌ MediaPlayer: Não foi possível criar nenhum player');
    return (
      <div className={`${className} bg-black flex items-center justify-center`}>
        <div className="text-white text-center">
          <p>Erro: Não foi possível carregar o player</p>
          <p className="text-sm mt-2">Provider: {mediaMapping?.provider || detectedProvider}</p>
        </div>
      </div>
    );
  }

  return player;
};

export default MediaPlayer;
